"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceContent = void 0;
const react_1 = __importDefault(require("react"));
require("./ResourceContent.scss");
const ResourceContent_scss_json_1 = __importDefault(require("./ResourceContent.scss.json"));
const package_1 = require("../package");
const Resource_1 = require("../shapes/Resource");
const ImageView_1 = require("lincd-schema/lib/components/ImageView");
exports.ResourceContent = (0, package_1.linkedComponent)(Resource_1.Resource.request((resource) => ({
    name: resource.name,
    id: resource.identifier,
    image: resource.image,
})), ({ linkedData, content }) => {
    let { name, image, id } = linkedData;
    return (react_1.default.createElement("div", { className: ResourceContent_scss_json_1.default.ResourceContent },
        react_1.default.createElement("div", { className: ResourceContent_scss_json_1.default.bannerContainer },
            react_1.default.createElement(ImageView_1.ImageView, { of: image })),
        react_1.default.createElement("div", { className: ResourceContent_scss_json_1.default.Content }, content)));
});
//register all components in this file
(0, package_1.registerPackageModule)(module);
//# sourceMappingURL=ResourceContent.js.map